<div class="full-height-flex">
  <div class='full-height' [ngClass]='boxShadowClass'>
    <div class='full-height-flex'>
      <div class='remaining-space-flex-content-wrapper'>
        <div class='remaining-space-flex-content'>
          <div class='full-height-flex' [class.info-container]='shouldDisplaySearchContent() || isLoading' #editorContainer>
            @if (shouldDisplaySearchContent()) {
              <div class='resource-info-content'>
                <mat-icon>search</mat-icon>
                Please select a resource to see details
              </div>
            }
            @if (isLoading) {
              <span class='resource-info-content'><mat-spinner [diameter]='60'></mat-spinner></span>
            }
            @if (isLoading) {
              <span class='resource-info-content'> Loading the resource from the Kubernetes cluster. Please wait...</span>
            }
            @if (content) {
              <ngx-monaco-editor
                [(ngModel)]='content'
                [options]='editorOptions'
                (onInit)='initializeEditor($event)'>
              </ngx-monaco-editor>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
